// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* G42 Sans from client/src/assets/fonts */
@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: 400 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
  font-weight: 400 500;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans Black Regular';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
  font-weight: 700 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
  font-weight: 700 900;
  font-style: italic;
  font-display: swap;
}

body,
html,
.Root {
  font-family:
    'G42 Sans',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

html,
body {
  /* Prevent pull down to refresh behavior on mobile */
  overscroll-behavior-y: contain;
}

.wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.assessment-mode-btn:focus-visible {
  outline: none;
  border: 1px solid #0000000d;
}

strong {
  font-weight: 500 !important;
}

.assessment-initiation,
.assessment-initiation {
  font-family: 'G42 Sans' !important;
}
.assessment-initiation {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 16px !important;
}

.assessment-initiation-start-btn:hover:not(:disabled) {
  background-color: #05a27d !important;
  box-shadow: 0 4px 12px rgba(6, 185, 143, 0.35) !important;
  transform: translateY(-1px);
}

.learning-recommendations-btn:hover:not(:disabled) {
  background-color: #05a27d !important;
  box-shadow: 0 4px 12px rgba(6, 185, 143, 0.35) !important;
  transform: translateY(-1px);
}

.sidebar-avatar-btn:focus-visible {
  outline: 2px solid #00d2aa;
  outline-offset: 2px;
}

.sidebar-popover-item:hover,
.sidebar-popover-item:focus {
  background-color: #f5f5f4;
}
.sidebar-popover-item:focus-visible {
  outline: none;
  background-color: #f5f5f4;
}

@keyframes openai-widget-spin {
  to {
    transform: rotate(360deg);
  }
}
.openai-widget-button-loader {
  width: 80px;
  height: 80px;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  border: 4px solid rgba(0, 210, 170, 0.25);
  border-top-color: #00d2aa;
  border-radius: 50%;
  animation: openai-widget-spin 0.7s linear infinite;
}

/* Workflow flowchart step width:
 * - Default is 223px via inline style
 * - Narrow to 200px when viewport is exactly 1920x1080 (approximate 1920x1080 @ 50% zoom scenario)
 */

@media (max-width: 1351px) {
  .workflow-flow-step {
    width: 200px !important;
  }
  .assessment-initiation-start-btn {
    font-size: 16px !important;
    max-width: 210px !important;
  }
  .assessment-initiation {
    padding: 0 16px !important;
  }
}

/* Prevent selecting/copying agent question text (including long-press on mobile) */
.agent-question-text-container {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,uBAAuB;EACvB;;0DAEuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAE6E;EAC7E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAEwE;EACxE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAE8E;EAC9E,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC;;0DAEuE;EACvE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;2DAE6E;EAC7E,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE;;;;;;;;;;;;cAYY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,oDAAoD;EACpD,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;;;EAGE;;AAEF;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mFAAmF;AACnF;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B","sourcesContent":["/* G42 Sans from client/src/assets/fonts */\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-Light.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-Light.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-LightItalic.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-LightItalic.woff') format('woff');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-Medium.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-Medium.woff') format('woff');\n  font-weight: 400 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-MediumItalic.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-MediumItalic.woff') format('woff');\n  font-weight: 400 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans Black Regular';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-Black.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-Black.woff') format('woff');\n  font-weight: 700 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-BlackItalic.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-BlackItalic.woff') format('woff');\n  font-weight: 700 900;\n  font-style: italic;\n  font-display: swap;\n}\n\nbody,\nhtml,\n.Root {\n  font-family:\n    'G42 Sans',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    'Roboto',\n    'Oxygen',\n    'Ubuntu',\n    'Cantarell',\n    'Fira Sans',\n    'Droid Sans',\n    'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\nhtml,\nbody {\n  /* Prevent pull down to refresh behavior on mobile */\n  overscroll-behavior-y: contain;\n}\n\n.wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.assessment-mode-btn:focus-visible {\n  outline: none;\n  border: 1px solid #0000000d;\n}\n\nstrong {\n  font-weight: 500 !important;\n}\n\n.assessment-initiation,\n.assessment-initiation {\n  font-family: 'G42 Sans' !important;\n}\n.assessment-initiation {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 16px !important;\n}\n\n.assessment-initiation-start-btn:hover:not(:disabled) {\n  background-color: #05a27d !important;\n  box-shadow: 0 4px 12px rgba(6, 185, 143, 0.35) !important;\n  transform: translateY(-1px);\n}\n\n.learning-recommendations-btn:hover:not(:disabled) {\n  background-color: #05a27d !important;\n  box-shadow: 0 4px 12px rgba(6, 185, 143, 0.35) !important;\n  transform: translateY(-1px);\n}\n\n.sidebar-avatar-btn:focus-visible {\n  outline: 2px solid #00d2aa;\n  outline-offset: 2px;\n}\n\n.sidebar-popover-item:hover,\n.sidebar-popover-item:focus {\n  background-color: #f5f5f4;\n}\n.sidebar-popover-item:focus-visible {\n  outline: none;\n  background-color: #f5f5f4;\n}\n\n@keyframes openai-widget-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.openai-widget-button-loader {\n  width: 80px;\n  height: 80px;\n  margin-top: 10px;\n  margin-left: auto;\n  margin-right: auto;\n  border: 4px solid rgba(0, 210, 170, 0.25);\n  border-top-color: #00d2aa;\n  border-radius: 50%;\n  animation: openai-widget-spin 0.7s linear infinite;\n}\n\n/* Workflow flowchart step width:\n * - Default is 223px via inline style\n * - Narrow to 200px when viewport is exactly 1920x1080 (approximate 1920x1080 @ 50% zoom scenario)\n */\n\n@media (max-width: 1351px) {\n  .workflow-flow-step {\n    width: 200px !important;\n  }\n  .assessment-initiation-start-btn {\n    font-size: 16px !important;\n    max-width: 210px !important;\n  }\n  .assessment-initiation {\n    padding: 0 16px !important;\n  }\n}\n\n/* Prevent selecting/copying agent question text (including long-press on mobile) */\n.agent-question-text-container {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
